import React, { useState, useEffect, useCallback } from 'react';
import { Routes, Route, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import Joyride, { Step, CallBackProps } from "react-joyride";
import OverviewPage from './pages/home';
import IssuedCertificatesPage from './pages/issuedCertificatePage';
import AssignedCertificates from './pages/assignedCertificates';
import ReviewAssignedCertificates from './pages/reviewAssignedcertificates';
import Header from './components/header';
import ManageUsers from './pages/manageUsers';
import PendingRequest from './pages/pendingRequests';
import AllRequests from './pages/allRequests';
import ReviewRequestPage from './pages/reviewRequest';
import ErrorModal from './components/errormodal';
import Toaster from './components/toaster';
import { useSelector, useDispatch } from 'react-redux';
import { Login } from './pages/login';
import { UnAuthorized } from './pages/unautherized';
import { DownTime } from './pages/serverdown';
import { NoAccess } from './pages/noaccess';
import PCMSGuidedTourModal from './components/walktour';
import { setCurrentUser } from './store/slices/formconfig';
import { post } from './config/api';
import { API_ENDPOINTS } from './constants/apiEndpoints';

import { getGuidedTourConfig } from './config/guidedTour'; // NEW
import { ReviewCertificate } from './pages/reviewcertificates';
import { ROLES } from './constants/textconstants';


function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const showHeader = location.pathname !== '/login' && location.pathname !== '/unautherized' && location.pathname !== '/noaccess' && location.pathname !== '/notresponding' && location.pathname !== '/review-certificates';
  const userData = useSelector((state: any) => state.formConfig.user);
  const [tourSteps, setTourSteps] = useState<Step[]>([]);
  const [routesForStep, setRoutesForStep] = useState<(string | undefined)[]>([]);

  useEffect(() => {
    // initialize guided tour based on user role whenever userData.role changes
    const detectedRole = userData?.role || ROLES.ISSUER;
    const config = getGuidedTourConfig(detectedRole);
    setTourSteps(config.steps);
    setRoutesForStep(config.routesForStep);
  }, [userData?.role]);


  const [runTour, setRunTour] = useState(false);
  const [showTourModal, setShowTourModal] = useState(false);
  const [joyrideKey, setJoyrideKey] = useState(0);
  const [stepIndex, setStepIndex] = useState(0);
  // const routesForStep: (string | undefined)[] = [
  //     '/', // step 0: overview
  //     '/all-requests/0', // step 1
  //     '/review-request/1', // step 2
  //     '/all-requests/1', // step 3
  //     '/review-request/2', // step 4
  //     '/all-requests/2', // step 5
  //     '/review-request/3' // step 6
  //   ];
  const waitForSelector = (selector?: string, timeout = 3000) => {
    return new Promise<void>((resolve) => {
      if (!selector) return resolve();
      const intervalMs = 100;
      let elapsed = 0;
      const id = setInterval(() => {
        if (document.querySelector(selector) || elapsed >= timeout) {
          clearInterval(id);
          resolve();
        }
        elapsed += intervalMs;
      }, intervalMs);
    });
  };



  // useEffect(() => {
  //   // Example of dynamically adding a step based on user data
  //   if (userData?.role === 'admin') {
  //     const adminStep: Step = {
  //       target: ".manage-users-link", // Assuming you have a link with this class for admins
  //       content: "As an admin, you can manage users from here.",
  //       placement: "bottom",
  //       title: "Admin Step",
  //     };

  //     // Add the admin step if it's not already there
  //     if (!tourSteps.find(step => step.target === ".manage-users-link")) {
  //       setTourSteps([...initialTourSteps, adminStep]);
  //     }
  //   }
  // }, [userData, tourSteps]);

  useEffect(() => {
    if (userData && userData.is_viewed_guided_tour === false) {
      setShowTourModal(true);
    }
  }, [userData]);

  const handleTakeTour = useCallback(() => {
    setShowTourModal(false);
    setStepIndex(0); // start from the first step when starting tour
    setRunTour(true);
  }, []);

  const completeTutorial = async () => {
    setRunTour(false);
    setShowTourModal(false);


    if (location.pathname === '/') {
      const updatedUser = { ...userData, is_viewed_guided_tour: true };
      dispatch(setCurrentUser(updatedUser));
    } else {
      const updatedUser = { ...userData, is_viewed_guided_tour: true };
      dispatch(setCurrentUser(updatedUser));
      navigate('/');
    }
  };

  const handleJoyrideCallback = useCallback((data: CallBackProps) => {
    const { action, index, type, status } = data;

    if (action === 'skip' || action === 'close' || status === 'finished') {
      completeTutorial();
      setStepIndex(0);
      setRunTour(false);
      return;
    }

    if (type === 'step:after') {
   
      if (action === 'next') {

        const currentStepIndex = index;
        if (userData && !userData.last_step_viewed) {
         
          post(API_ENDPOINTS.USER_VIEWED_GUIDED_TOUR_STEP(userData.userId, currentStepIndex), {})
            .then(() => {

            })
            .catch(err => {
              // Handle error if needed
              console.error("Failed to update guided tour step", err);
            });
        } else if (userData && userData.last_step_viewed < currentStepIndex) {
          
          post(API_ENDPOINTS.USER_VIEWED_GUIDED_TOUR_STEP(userData.userId, currentStepIndex), {})
            .then(() => {
            })
            .catch(err => {
              // Handle error if needed
              console.error("Failed to update guided tour step", err);
            });
        }
      }


      if (action === 'next') {
     
        const nextIndex = index + 1;
        if (nextIndex >= tourSteps.length) {
          completeTutorial();
          setStepIndex(0);
          setRunTour(false);
          return;
        }
        setStepIndex(nextIndex);

        const targetRoute = routesForStep[nextIndex];
        if (targetRoute) {
          setRunTour(false);
          navigate(targetRoute);
          const nextStepTarget = (tourSteps[nextIndex] && (tourSteps[nextIndex].target as string)) || undefined;
          waitForSelector(nextStepTarget, 2500).then(() => {
            setJoyrideKey(k => k + 1);
            setRunTour(true);
          });
        }
      }

      if (action === 'prev') {
        const prevIndex = index - 1;
        if (prevIndex < 0) return;
        setStepIndex(prevIndex);

        const targetRoute = routesForStep[prevIndex];
        if (targetRoute) {
          setRunTour(false);
          navigate(targetRoute, { state: { fromGuidedTour: true } });
          const prevStepTarget = (tourSteps[prevIndex] && (tourSteps[prevIndex].target as string)) || undefined;
          waitForSelector(prevStepTarget, 2500).then(() => {
            setJoyrideKey(k => k + 1);
            setRunTour(true);
          });
        }
      }
    }

    if (type === 'error:target_not_found') {

      setRunTour(false);
      setTimeout(() => {
        setStepIndex(s => Math.min(s + 1, tourSteps.length - 1));
        setJoyrideKey(k => k + 1);
        setRunTour(true);
      }, 500);
    }
  }, [navigate, completeTutorial, tourSteps, routesForStep]);

  return (
    <>
      {showHeader && <Header triggerTour={() => {
        setShowTourModal(true);
        const updatedUser = { ...userData, is_viewed_guided_tour: false };
        dispatch(setCurrentUser(updatedUser));
      }} />}
      <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/issued-certificates" element={<IssuedCertificatesPage />} />
        <Route path="/pending-requests" element={<PendingRequest />} />
        <Route path="/all-requests/:id" element={<AllRequests />} />
        <Route path="/assigned-certificates" element={<AssignedCertificates />} />
        <Route path="/assigned-certificates/:assignedId" element={<ReviewAssignedCertificates />} />
        <Route path="/manage-users" element={<ManageUsers />} />
        <Route path="/review-request/:id" element={<ReviewRequestPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/unautherized" element={<UnAuthorized />} />
        <Route path="/notresponding" element={<DownTime />} />
        <Route path="/noaccess" element={<NoAccess />} />
      </Routes>

      <PCMSGuidedTourModal show={showTourModal} onTakeTour={handleTakeTour} onMayBeLater={completeTutorial} />
      <ErrorModal

      />
      <Toaster />
      <Joyride
        key={joyrideKey}
        run={runTour}
        steps={tourSteps}
        hideCloseButton={true}
        showSkipButton={true}
        stepIndex={stepIndex}
        continuous
        disableOverlayClose
        showProgress
        locale={{
          last: 'Done',
          skip: 'Skip Tour',
          next: 'Next',
          back: 'Previous',
          close: 'Close',
          nextLabelWithProgress: 'Next',
        }}
        styles={{
          options: { primaryColor: '#5EA611', textColor: '#fff', arrowColor: '#F1F9E7' },
          buttonNext: { padding: '14px 20px', fontSize: 14 },
          buttonSkip: { color: 'rgba(0, 0, 0, 0.60)', fontSize: 14 },
          buttonBack: {
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '24px',
            letterSpacing: '0.4px'
          }
        }}
        callback={handleJoyrideCallback}
      />
    </>
  );
}

export default App;